import { IconButton, Menu, MenuItem } from '@mui/material';
import { DotsVertical, TableEdit } from 'mdi-material-ui';
import { MutableRefObject, useState } from 'react';
import { DataGridAction, DefaultActions } from '../datagrid-types';
import { DataGridRef } from 'devextreme-react/data-grid';
import { setSelectedEntityId } from 'src/store/slices/attachmentsDataSlice';
import { useAppDispatch } from 'src/store/baseHooks';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RowActions = ({
  row,
  actions,
  defaultActions,
  rowIndex,
  gridRef
}: {
  row: any;
  actions: DataGridAction[];
  defaultActions?: DefaultActions;
  rowIndex: number;
  gridRef?: MutableRefObject<DataGridRef<any, any> | null>;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const rowOptionsOpen = Boolean(anchorEl);
  const uiFlowDispatch = useAppDispatch();

  const handleRowOptionsClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleRowOptionsClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {Boolean(actions.filter(x => !x.alwaysShow).length) && null}
      {actions.filter(x => !x.alwaysShow).length > 0 && (
        <>
          <IconButton size="small" onClick={handleRowOptionsClick}>
            <DotsVertical />
          </IconButton>
          <Menu
            keepMounted
            anchorEl={anchorEl}
            open={rowOptionsOpen}
            onClose={handleRowOptionsClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            PaperProps={{ style: { minWidth: '8rem' } }}>
            {actions
              .filter(action => !action.alwaysShow)
              .map(action => (
                <MenuItem
                  key={action.id}
                  sx={{ gap: '10px' }}
                  disabled={action.disableCallback?.(row) ?? false}
                  onClick={() => {
                    uiFlowDispatch(setSelectedEntityId((row.id as string) ?? ''));
                    action.clickHandler(row, action);
                    handleRowOptionsClose();
                  }}>
                  {action.icon}
                  {action.text}
                </MenuItem>
              ))}
            {defaultActions && defaultActions.canRowEdit && (
              <MenuItem
                sx={{ gap: '10px' }}
                onClick={() => {
                  gridRef?.current?.instance()?.editRow(rowIndex);
                  handleRowOptionsClose();
                }}>
                <TableEdit />
                Edit Row
              </MenuItem>
            )}
          </Menu>
        </>
      )}
    </>
  );
};

export default RowActions;
